import Api from './Api'
import cookieType from "@/config/cookieType";
import Vue from "vue";
import { API_VERSION, BASEURL } from '@/config/index'
import axios from 'axios'

export default {
  UploadImage(payload) {
    return axios.post(`${BASEURL}/admin/uploads/image`, payload.formData, {
      headers: {
        'Authorization': Vue.cookie.get(cookieType.MCHASHID),
        'content-type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*'
      },
      params: payload.params
    });
  },
  RemoveImage(payload) {
    let urlparams = new URLSearchParams()
    urlparams.append('image_type', payload.image_type)
    urlparams.append('filename', payload.filename)
    let query = `?${urlparams.toString()}`
    return Api().delete(`/admin/uploads/image/${query}`)
  },
  UploadDocument(payload) {
    return axios.post(`${BASEURL}/admin/uploads/doc`, payload.formData, {
      headers: {
        'Authorization': Vue.cookie.get(cookieType.MCHASHID),
        'content-type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*'
      },
      params: payload.params
    });
  },
  GetAllUsersAndUserTypes(payload) {
    return Api().get(`/admin/master/all-users-and-types`, { params: payload })
  },
  GetAllCourseLevels(payload) {
    return Api().get(`/admin/master/course-levels`, { params: payload })
  },
  GetAllCourseCategories(payload) {
    return Api().get(`/admin/master/course-categories`, { params: payload })
  },
  GetUniversities(payload) {
    return Api().get(`/admin/master/universities`, { params: payload })
  },
  // GetSchools(university_id) {
  //   return Api().get(`/admin/master/schools/${university_id}`)
  // },


  // Master Documents
  GetAllDocuments(payload) {
    return Api().get(`/admin/master/document`, { params: payload })
  },
  GetSingleDocument(doc_id) {
    return Api().get(`/admin/master/document/${doc_id}`)
  },
  AddDocument(payload) {
    return Api().post(`/admin/master/document`, payload)
  },
  EditDocument(payload) {
    return Api().put(`/admin/master/document/${payload.doc_id}`, payload)
  },

  // Master Documents
  GetAllApplicationChecklist(payload) {
    return Api().get(`/admin/master/application-checklist`, { params: payload })
  },
  GetSingleApplicationChecklist(ac_id) {
    return Api().get(`/admin/master/application-checklist/${ac_id}`)
  },
  SaveApplicationChecklist(payload) {
    return Api().post(`/admin/master/application-checklist`, payload)
  },

  // Master Documents
  GetAllVisaDocuments(payload) {
    return Api().get(`/admin/master/visa-document`, { params: payload })
  },
  GetSingleVisaDocument(vdoc_id) {
    return Api().get(`/admin/master/visa-document/${vdoc_id}`)
  },
  SaveVisaDocument(payload) {
    return Api().post(`/admin/master/visa-document`, payload)
  },

  // Master Documents
  GetAllVisaChecklist(payload) {
    return Api().get(`/admin/master/visa-checklist`, { params: payload })
  },
  GetSingleVisaChecklist(vc_id) {
    return Api().get(`/admin/master/visa-checklist/${vc_id}`)
  },
  SaveVisaChecklist(payload) {
    return Api().post(`/admin/master/visa-checklist`, payload)
  },

  // Master Country
  GetAllCountries(payload) {
    return Api().get(`/admin/master/all-country`, { params: payload })
  },
  GetCountries(payload) {
    return Api().get(`/admin/master/country`, { params: payload })
  },
  GetSingleCountry(country_id) {
    return Api().get(`/admin/master/country/${country_id}`)
  },
  SaveCountry(payload) {
    return Api().post(`/admin/master/country`, payload)
  },

  // Master State
  GetAllStates(payload) {
    return Api().get(`/admin/master/all-state`, { params: payload });
  },
  GetStates(payload) {
    return Api().get(`/admin/master/state`, { params: payload });
  },
  GetSingleState(state_id) {
    return Api().get(`/admin/master/state/${state_id}`)
  },
  AddState(payload) {
    return Api().post(`/admin/master/state`, payload)
  },
  EditState(payload) {
    return Api().put(`/admin/master/state/${payload.state_id}`, payload)
  },

  // Master City
  GetAllCities(payload) {
    return Api().get(`/admin/master/all-city`, { params: payload })
  },
  GetCities(payload) {
    return Api().get(`/admin/master/city`, { params: payload })
  },
  GetSingleCity(city_id) {
    return Api().get(`/admin/master/city/${city_id}`)
  },
  AddCity(payload) {
    return Api().post(`/admin/master/city`, payload)
  },
  EditCity(payload) {
    return Api().put(`/admin/master/city/${payload.city_id}`, payload)
  },

  // Swed
  GetAllSwedCourseCategories() {
    return Api().get(`/admin/swed-master/course-categories`)
  },

}



// WEBPACK FOOTER //
// ./src/apiServices/MasterServices.js